export default "__VITE_ASSET__Ctlv02Bk__"